import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const fetchPreferences = async () => {
  const response = await axiosInstance.get('/notifications/preferences/');
  return response.data;
};

export const useGetPreferences = (options = {}) => {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['notifications', 'preferences'],
    queryFn: fetchPreferences,
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  return {
    categories: data?.categories,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
